module.exports = "<div class=\"am-dashbord\">\r\n  <am-assets></am-assets>\r\n  <am-operators></am-operators>\r\n</div>";